<template>
  <div>
    <!-- Step 1: DO Reference Input -->
    <div class="vx-row mt-0">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label pl-1">DO Reference</label>
        <vs-input
          class="w-full"
          v-model="doReference"
          placeholder="Enter DO reference"
          @keyup.enter="searchPreview"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full" style="display:flex;align-items:flex-end;">
        <vs-button
          color="warning"
          class="btn mb-4 md:mb-0"
          @click="searchPreview"
          :disabled="doReference == ''"
        >
          Search
        </vs-button>
      </div>
    </div>

    <!-- Step 2: Preview Section -->
    <div class="vx-row mt-6" v-if="showPreview">
      <!-- DO Info -->
      <div class="vx-col md:w-1/2 w-full">
        <vs-card>
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">DO Info</span>
          </div>
          <table style="width:100%">
            <tr>
              <td style="padding:4px 0;font-weight:bold;width:40%;">DO Reference</td>
              <td style="padding:4px 0;">{{ previewData.do_reference }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Status</td>
              <td style="padding:4px 0;">{{ previewData.do_status }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">TV Qty</td>
              <td style="padding:4px 0;">{{ previewData.tv_qty }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Bracket Qty</td>
              <td style="padding:4px 0;">{{ previewData.bracket_qty }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Bracket Base Qty</td>
              <td style="padding:4px 0;">{{ previewData.bracket_base_qty }}</td>
            </tr>
          </table>
        </vs-card>
      </div>

      <!-- Records Akan Diupdate -->
      <div class="vx-col md:w-1/2 w-full">
        <vs-card>
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">Records Akan Diupdate</span>
          </div>
          <table style="width:100%">
            <tr>
              <td style="padding:4px 0;font-weight:bold;width:60%;">Inventories Transactions</td>
              <td style="padding:4px 0;">{{ previewData.transactions_count }} record(s)</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">DO Details</td>
              <td style="padding:4px 0;">Akan dihapus</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Delivery Order</td>
              <td style="padding:4px 0;">Akan dihapus</td>
            </tr>
          </table>
        </vs-card>
      </div>
    </div>

    <!-- Step 3: Process Button -->
    <div class="vx-row mt-5" v-if="showPreview">
      <div class="vx-col md:w-1/4 w-full">
        <vs-button
          color="primary"
          @click="processCancelGI"
          :disabled="isSubmitting"
        >
          Process
        </vs-button>
      </div>
    </div>

    <!-- Confirm Modal -->
    <vs-popup title="Konfirmasi Cancel GI" :active.sync="showConfirmModal" v-if="previewData">
      <p style="margin-bottom:12px;">Apakah kamu yakin ingin membatalkan Good Issue untuk DO berikut?</p>
      <table style="width:100%;margin-bottom:16px;">
        <tr>
          <td style="padding:4px 0;font-weight:bold;width:40%;">DO Reference</td>
          <td style="padding:4px 0;">{{ doReference }}</td>
        </tr>
        <tr>
          <td style="padding:4px 0;font-weight:bold;">TV Qty</td>
          <td style="padding:4px 0;">{{ previewData.tv_qty }}</td>
        </tr>
        <tr>
          <td style="padding:4px 0;font-weight:bold;">Bracket Qty</td>
          <td style="padding:4px 0;">{{ previewData.bracket_qty }}</td>
        </tr>
      </table>
      <div style="display:flex;justify-content:flex-end;">
        <vs-button color="grey" class="btn mr-2" @click="showConfirmModal = false">Batal</vs-button>
        <vs-button color="warning" class="btn" @click="confirmCancelGI">Ya, Cancel GI</vs-button>
      </div>
    </vs-popup>

    <!-- Result Section -->
    <div class="vx-row mt-10" v-if="result">
      <div class="vx-col md:w-full w-full">
        <div style="font-size:14px;font-weight:700;margin-bottom:12px;">Hasil Cancel GI</div>
        <div style="border:1px solid #ddd;border-radius:4px;overflow:hidden;">
          <div class="vx-row" style="border-bottom:1px solid #ddd;">
            <div class="vx-col md:w-1/3" style="border-right:1px solid #ddd;padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:14px;font-weight:600;">DO REFERENCE</span>
            </div>
            <div class="vx-col md:w-1/3" style="border-right:1px solid #ddd;padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:14px;font-weight:600;">INVENTORIES CREATED</span>
            </div>
            <div class="vx-col md:w-1/3" style="padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:14px;font-weight:600;">DO DELETED</span>
            </div>
          </div>
          <div class="vx-row" style="border-bottom:1px solid #ddd;">
            <div class="vx-col md:w-1/3" style="border-right:1px solid #ddd;padding:12px 16px;">
              <span style="font-size:14px;">{{ result.do_reference }}</span>
            </div>
            <div class="vx-col md:w-1/3" style="border-right:1px solid #ddd;padding:12px 16px;">
              <span style="font-size:14px;">{{ result.inventories_created }}</span>
            </div>
            <div class="vx-col md:w-1/3" style="padding:12px 16px;">
              <span style="font-size:14px;">{{ result.delivery_order_deleted ? 'Ya' : 'Tidak' }}</span>
            </div>
          </div>
          <div class="vx-row" style="border-top:1px solid #ddd;background:#f0f0f0;">
            <div class="vx-col md:w-1/3" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Outbound Details Updated: </span>
              <span style="font-size:14px;font-weight:600;">{{ result.outbound_details_updated }}</span>
            </div>
            <div class="vx-col md:w-1/3" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">DO Details Deleted: </span>
              <span style="font-size:14px;font-weight:600;">{{ result.do_details_deleted }}</span>
            </div>
            <div class="vx-col md:w-1/3" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Transactions Deleted: </span>
              <span style="font-size:14px;font-weight:600;">{{ result.transactions_deleted }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CancelGiBasedOnDo",
  data() {
    return {
      doReference: "",
      previewData: null,
      showPreview: false,
      showConfirmModal: false,
      isSubmitting: false,
      result: null,
    };
  },
  methods: {
    searchPreview() {
      if (this.doReference == "") {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "DO Reference is required",
        });
        return false;
      }

      this.$emit("loading", true);
      this.showPreview = false;
      this.result = null;

      this.$http
        .post("support/outbound/deliveryorder/preview", {
          do_reference: this.doReference,
        })
        .then((res) => {
          this.previewData = res.data.data;
          this.showPreview = true;
          this.$emit("loading", false);
        })
        .catch((error) => {
          this.$emit("loading", false);
          this.$emit("error", error);
        });
    },

    processCancelGI() {
      this.showConfirmModal = true;
    },

    confirmCancelGI() {
      this.showConfirmModal = false;
      this.isSubmitting = true;
      this.$emit("loading", true);

      this.$http
        .post("support/outbound/deliveryorder/cancel-gi-new", {
          do_reference: this.doReference,
        })
        .then((res) => {
          this.result = res.data.data;
          this.isSubmitting = false;
          this.$emit("loading", false);
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: res.data.message || "Cancel GI berhasil diproses.",
          });
        })
        .catch((error) => {
          this.isSubmitting = false;
          this.$emit("loading", false);
          this.$emit("error", error);
        });
    },
  },
};
</script>
